<template lang="pug">
  section.episodes.content-section
    template( v-if='filteredEpisodes.length || showEmpty' )
      h2.title( v-html='title' )
      transition-group( name='fade-fast' )
        b-card.media-insert(
          v-for='( episode, index ) in filteredEpisodes'
          :key='episode.id'
          :class='cardClasses( episode )'
        )
          b-media( no-body )
            b-media-aside
              b-img( :src='episode.thumbnail' width='128' height='96' )
              .info.length {{ episode.media_details.length_-formatted }}
            b-media-body
              h5.mt-0.episode-num(
                v-if=`labels &&
                  episode.release_number &&
                  typeof episode.release_number == 'number'
                `
              )
                | Programme {{ episode.release_number }}
              h5.mt-0( v-html='episode.title.rendered' )
              .info.row
                .views.d-flex( :class='{ active : episode.my_xp.seen }' )
                  span.dashicons.dashicons-visibility
                  span.count
                    | {{ episode.stats.views || 0 }}
                .likes.d-flex( :class='{ active: episode.my_xp.like }' )
                  span.dashicons.dashicons-thumbs-up
                  span.count
                    | {{ episode.stats.likes || 0 }}
                .dislikes.d-flex( :class='{ active: episode.my_xp.dislike }' )
                  span.dashicons.dashicons-thumbs-down
                  span.count
                    | {{ episode.stats.dislikes || 0 }}
                .favs.d-flex( :class='{ active: episode.my_xp.fav }' )
                  span.dashicons.dashicons-star-filled
                  span.count
                    | {{ episode.stats.favs || 0 }}
                .comments.d-flex( :class='{ active: episode.my_xp.comment }' )
                  span.dashicons.dashicons-admin-comments
                  span.count
                    | {{ episode.stats.comments || 0 }}
                template( v-if='user && user.as && user.as.admin' )
                  .d-flex.admin( v-if='episode.restrictions.private' )
                    | private
                  .d-flex.admin( v-if='episode.restrictions.public' )
                    | public
                  .d-flex.admin( v-if='episode.restrictions.auth' )
                    | logged-in
                  .d-flex.admin( v-if='episode.restrictions.payperview' )
                    | payperview
                  .d-flex.admin( v-if='episode.restrictions.members' )
                    | subscribers
                  .d-flex.admin(
                    v-if='!episode.restrictions.show && !episode.restrictions.public' )
                    | hidden
                  .d-flex.admin( v-if='episode.restrictions.premium' )
                    | premium
              div( v-html='episode.caption.rendered' )
              watch-button( :target='episode' )
              b-btn.watch.watch-preview(
                v-if='episode.preview'
                size='lg'
                :to='episode.preview'
                variant='link'
              )
                | {{ sayAction( episode, true ) }} preview
      .message( v-if='!filteredEpisodes.length && !hideComing' )
        | Coming {{ dateComing }}!
</template>

<script lang="js">
import _ from 'lodash'
import mediaActions from '@/mixins/media-actions'
import WatchButton from './watch-button'
import { User } from '@/mixins'

export default {
  name: 'content-section',
  mixins: [ mediaActions, User ],
  components: { WatchButton },
  props: {
    title: {
      type: String,
      default: 'Episodes'
    },
    episodes: {
      type: Array,
      default: () => []
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    coming: {
      type: String,
      default: ''
    },
    hideComing: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    filteredEpisodes() {
      var episodes = _.orderBy( this.episodes, [ 'release_number' ], [ 'asc' ])
      return episodes.filter( x => this.canWatchNow(x) || x.restrictions.show )
    },
    dateComing() {
      return this.coming ? ( 'in ' + this.coming ) : 'Soon'
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/breakpoint';
@import '@/scss/vars';

.content-section {
  &.episodes {
    >.title {
      text-transform: uppercase;
    }
    .card {
      margin-bottom: 20px;
      background: rgba(255,255,255,0.1);
      .sharedaddy {
        display: none !important;
      }
      h5 {
        font-size: 110%;
        font-weight: bold;
        text-transform: capitalize;
      }
    }
  }
  .media-insert {
    &.private {
      background: #fffaf8;
    }
    &.hidden {
      display: flex !important;
      opacity: 0.5;
    }
  }
  .media {
    .media-aside {
      position: relative;
      margin-right: 10px;
      img {
        @include breakpoint( $max-phone ) {
          width: 96px;
          height: 72px;
        }
      }
      .info {
        position: absolute;
        bottom: 1px;
        padding: 1px 4px 0;
        &.length {
          border-top-left-radius: 4px;
          background: rgba(0,0,0,0.5);
          color: white;
          font-size: 90%;
          font-weight: bold;
          right: 1px;
        }
      }
    }
    .media-body {
      >.episode-num {
        text-transform: uppercase;
      }
      >.info {
        color: #aaa;
        margin: 0 0 10px;
        .admin {
          font-size: smaller;
          font-weight: bold;
          text-transform: uppercase;
        }
        .dashicons {
          margin-right: 1px;
          font-size: 18px;
        }
        .count {
          vertical-align: center;
          font-size: 13px;
        }
        > * {
          margin-right: 1em;
        }
        .views.active {
          color: deepskyblue;
        }
        .likes.active {
          color: green;
        }
        .dislikes.active {
          color: red;
        }
        .favs.active {
          color: orange;
        }
        .comments.active {
          color: purple;
        }
      }
    }
    .btn.watch {
      float: right;
    }
  }
}
</style>
